import PacingSchedule from './component'
export default PacingSchedule
